<app-entries-per-page (selected)="emitEntriesPerPage($event)"></app-entries-per-page>
<ng-content></ng-content>
<app-paginator [page]="page" (pageRequest)="emitPageRequest($event)"></app-paginator>
